import HalfYearType, { HalfYearTypeText } from 'consts/HalfYearType';
import RecruitmentType, { RecruitmentTypeText } from 'consts/RcruitmentType';

export const passReviewTitle = (recruitmentYear:number, haflYearType: keyof typeof HalfYearType, recruitmentType: keyof typeof RecruitmentType) => `${recruitmentYear} ${HalfYearTypeText[haflYearType]} ${RecruitmentTypeText[recruitmentType]} 합격자`;

export default ({ passReviewTitle });
